// LOOTUS — renderização somente-leitura da Descrição/Histórico do serviço,
// compartilhada entre Fichas (visualização), Aprovações e Assinatura
// (Sign.jsx). Fichas antigas (texto puro) continuam exatamente como antes
// (whitespace-pre-wrap, sem HTML nenhum — zero risco, zero mudança
// visual). Conteúdo rico passa por sanitização de exibição (defesa em
// profundidade — DOMPurify) antes de dangerouslySetInnerHTML; o backend já
// sanitizou antes de gravar (backend/security/rich_text.py), esta é só a
// segunda camada.
import { isLikelyRichHtml, sanitizeRichTextForDisplay } from "../lib/richText";

export default function RichTextView({ html, className = "", emptyText = "—" }) {
  if (!html) return <div className={className}>{emptyText}</div>;
  if (!isLikelyRichHtml(html)) {
    return <div className={`whitespace-pre-wrap ${className}`}>{html}</div>;
  }
  return (
    <div
      className={`rich-text-view ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizeRichTextForDisplay(html) }}
    />
  );
}
